import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { useLocalizedStrings } from 'app/localization/Context';

import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconWifi } from 'images/device/add-device/wifi.svg';
import { ReactComponent as IconEyeClosed } from 'images/device/add-device/eye-closed.svg';
import { ReactComponent as IconEyeOpen } from 'images/device/add-device/eye-open.svg';
import { ReactComponent as IconBackBlack } from 'images/general/back-black.svg';


export function ConnectToWifiNetwork({
    dismissHandler, setPageData, connectedSSIDInfo, setErrorId, setStage, onPasswordEntered
}) {
    const ad = useLocalizedStrings().addDeviceProcess;

    const [password, setPassword] = useState('');
    const [usePreviousPassword, setUsePreviousPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const onFocusPassword = useCallback((e) => {
        if (usePreviousPassword) {
            e.preventDefault();
            e.target.select();
            e.target.setSelectionRange(0, 999999);
        }
    }, [usePreviousPassword]);

    const onChangePassword = useCallback((e) => {
        setUsePreviousPassword(false);
        setPassword(e.target.value);
    }, []);

    const isValidPassword = useMemo(() => {
        return usePreviousPassword || password.length > 7;
    }, [usePreviousPassword, password]);

    const nextClick = useCallback(() => {
        if (isValidPassword)
            onPasswordEntered(connectedSSIDInfo.name, usePreviousPassword ? undefined : password);
    }, [connectedSSIDInfo, password, isValidPassword, onPasswordEntered, usePreviousPassword]);

    useEffect(() => {
        if (connectedSSIDInfo === undefined) {
            setErrorId("wifi_ssid_error_general");
            setStage('error');
        } else if (connectedSSIDInfo.error !== undefined) {
            if (connectedSSIDInfo.error === 1)
                setErrorId("wifi_ssid_error_1");
            else
                setErrorId("wifi_ssid_error_general");
            setStage('error');
        } else if (connectedSSIDInfo.connected === false) {
            setErrorId("wifi_not_connected");
            setStage('error');
        } else if (connectedSSIDInfo.connected === true) {
            // pass
            if (connectedSSIDInfo.remembered_password === true) {
                setUsePreviousPassword(true);
                setShowPassword(false);
            }
        } else { // maybe it's covered in the previous conditions
            setErrorId("wifi_ssid_error_general");
            setStage('error');
        }
    }, [connectedSSIDInfo, setErrorId, setStage]);

    return (
        <div className="add-device-page-content">
            <IconX className="nav-icon" /> <div className="nav-button" onClick={dismissHandler} />

            <div className="header">{ad.connectNetwork}</div>

            <div className="warn-info">{ad.wifiGHz}</div>

            <div className="wifi-group">
                <IconWifi className="icon" />
                <div className="label">{
                    connectedSSIDInfo ? (connectedSSIDInfo.name ? connectedSSIDInfo.name : "") : ""
                }</div>
                {/* <div /> */}
                {/* <div className="change-button-border">
                    <div className="label">{ad.change}</div>
                    <IconChange className="icon" />
                </div> */}
            </div>

            <div className="input-header-label for-wifi-password">{ad.password}</div>
            <div className="input-container" dir="ltr" lang="en">
                {
                    !usePreviousPassword ?
                        React.createElement(showPassword ? IconEyeOpen : IconEyeClosed, { className: "eye icon" }) : null
                }
                <input className="input"
                    value={usePreviousPassword ? '............' : password}
                    onChange={onChangePassword} onFocus={onFocusPassword} onMouseUp={(e) => e.preventDefault()}
                    type={showPassword ? "text" : "password"}></input>
                {!usePreviousPassword ? <div className="eye button" onClick={() => { setShowPassword(!showPassword) }} /> : null}
            </div>


            {!isValidPassword ? <div className="error-label">{ad.passwordError}</div> : null}
            <div className="bottom-blue-button" onClick={nextClick} style={{ opacity: isValidPassword ? 1 : 0.3 }}>
                <div>{ad.next}</div> <IconBackBlack className="icon-180" />
            </div>
        </div>
    );
}
